import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAnalytics } from 'firebase/analytics';
import './assets/scss/main.scss';
import {BootstrapVue, BootstrapVueIcons} from "bootstrap-vue";

const config = require("./firebaseconfig.js");

axios.interceptors.request.use(async axiosConfig => {
	const user = firebase.auth().currentUser;
	if (user) {
		const token = await user.getIdToken();
		axiosConfig.headers.Authorization = `Bearer ${token}`;
	}
	return axiosConfig;
});

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

firebase.initializeApp(config.firebase);

// App Check — debug token auto-generated in dev (register it in Firebase Console > App Check)
if (process.env.NODE_ENV !== 'production') {
	self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
// App Check needs a reCAPTCHA v3 site key (config.appCheckSiteKey in firebaseconfig.js).
// Skip init when it is absent so a missing local config doesn't crash the whole app
// (ReCaptchaV3Provider throws "Missing required parameters: sitekey" on an empty key).
if (config.appCheckSiteKey) {
	initializeAppCheck(firebase.app(), {
		provider: new ReCaptchaV3Provider(config.appCheckSiteKey),
		isTokenAutoRefreshEnabled: true
	});
} else {
	console.warn('App Check disabled: config.appCheckSiteKey is missing from firebaseconfig.js');
}

getAnalytics(firebase.app());

let app;
firebase.auth().onAuthStateChanged(user => {
	if (!app) {
		app = new Vue({
			router,
			store,
			render: h => h(App)
		}).$mount('#app')
	}
}, error => {
	console.error(error);
});
